import axios from './axios-auth';

const getCompany = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/company',
      method: 'GET',
    })
      .then((resp) => {
        const company = {
          name: resp.data.name,
          loginCopyHtml: resp.data.loginCopyHtml,
          customLoginId: resp.data.customLoginId,
          logoUrl: resp.data.logoUrl,
          bannerUrl: resp.data.bannerUrl,
          blogHeading: resp.data.blogHeading,
          blogUrl: resp.data.blogUrl,
          homepageMessageHtml: resp.data.homepageMessageHtml,
          programNameHtml: resp.data.programNameHtml,
          programDescriptionHtml: resp.data.programDescriptionHtml,
          requireCredentialsForCheckout: resp.data.requireCredentialsForCheckout,
          allowTaxPaymentWithPoints: resp.data.tax?.allowTaxPaymentWithPoints,
          grossUpTaxes: resp.data.tax?.grossUpTaxes,
          stripeCustomerId : resp.data.stripeCustomerId,
          canUseNewFunding: resp.data.canUseNewFunding,
          ratio: resp.data.ratio,
          unallocDeposit: resp.data.unallocDeposit,
          minpointvalue: resp.data.minpointvalue,
          maxpointvalue: resp.data.maxpointvalue
        };
        resolve(company);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getCompanyPopups = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/company/popup',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data.items);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getCompanyBonusPointsConfig = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/company/bonusPoints',
      method: 'GET',
    })
      .then((resp) => {
        const config = {
          isEnabled: resp.data.isEnabled,
          menuItem: resp.data.menuItem,
          pageTitle: resp.data.pageTitle,
          pageMessage: resp.data.pageMessage,
          pointsAlias: resp.data.pointsAlias,
          iconClass: resp.data.iconClass,
        };
        resolve(config);
      })
      .catch((err) => {
        reject(err);
      });
  });

export { getCompany, getCompanyPopups, getCompanyBonusPointsConfig };
